import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import IconButtonSetting from "../../../../../../../components/Button/IconButtonSetting";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { Dt1_TableData } from "./Get_Dt1_table";


export default function Dt1_Variants() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
        
<IconButton onClick={handleOpen} size="small" >
            <IconButtonSetting />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

title='Diabetes Type 1 - Variants'

content={ <Dt1_TableData />}

/>

</>
)}